/* global axios */
import ApiClient from '../ApiClient';

class WgptCustomReportsAPI extends ApiClient {
  constructor() {
    super('custom_reports', { accountScoped: true, wgpt: true });
  }

  chat({ message, currentConfig, reportId }) {
    return axios.post(`${this.url}/chat`, {
      message,
      current_config: currentConfig,
      report_id: reportId,
    });
  }

  chatState(reportId) {
    return axios.get(`${this.url}/chat_state`, {
      params: reportId ? { report_id: reportId } : {},
    });
  }

  chatReset(reportId) {
    return axios.delete(`${this.url}/chat_reset`, {
      params: reportId ? { report_id: reportId } : {},
    });
  }

  query(reportId, params = {}) {
    return axios.get(`${this.url}/${reportId}/query`, { params });
  }

  drilldown({ reportId, params, page, signal }) {
    return axios.get(`${this.url}/${reportId}/drilldown`, {
      params: { ...params, page },
      signal,
    });
  }
}

export default new WgptCustomReportsAPI();
